var HYUNDAI_ESAF_09HN1 = {
  name: "ESAF-09HN1",
  defaultCommandIndex: 1,
  commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [199,0,5,128,2,17,6,118,2,181,1,190,17,203,16,115,2,71,20,117,2,0,0,55,90,215,111,189,86,189,85,87,226,110,181,174,223,122,173,122,170,175,194],
		},
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,13,6,124,2,188,1,223,17,236,16,107,2,58,20,104,2,0,0,55,90,215,119,246,170,170,170,191,226,110,181,174,239,237,85,85,85,127,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,20,6,119,2,185,1,185,17,249,16,107,2,78,20,110,2,0,0,55,90,215,119,246,170,170,213,123,226,110,181,174,239,237,85,85,170,247,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,199,17,229,16,121,2,19,6,119,2,179,1,105,2,84,20,115,2,0,0,165,73,73,73,82,165,85,74,73,36,146,164,146,164,170,141,42,74,74,74,149,42,170,82,73,36,149,36,149,37,84,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,125,2,4,6,128,2,172,1,154,17,12,17,107,2,86,20,107,2,0,0,55,90,215,119,246,170,171,85,119,226,110,181,174,239,237,85,86,170,239,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,4,6,128,2,168,1,206,17,214,16,107,2,61,20,108,2,0,0,55,90,215,119,246,170,174,170,215,226,110,181,174,239,237,85,93,85,175,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,11,6,123,2,175,1,202,17,232,16,110,2,76,20,105,2,0,0,55,90,215,119,246,170,175,85,171,226,110,181,174,239,237,85,94,171,87,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,122,2,10,6,123,2,179,1,200,17,234,16,102,2,74,20,106,2,0,0,55,90,215,119,246,170,173,170,219,226,110,181,174,239,237,85,91,85,183,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,119,2,11,6,123,2,182,1,227,17,226,16,104,2,86,20,104,2,0,0,55,90,215,119,246,170,173,85,111,226,110,181,174,239,237,85,90,170,223,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,7,6,125,2,173,1,201,17,232,16,106,2,82,20,105,2,0,0,55,90,215,119,246,170,186,170,175,226,110,181,174,239,237,85,117,85,95,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,125,2,5,6,124,2,174,1,232,17,225,16,106,2,78,20,107,2,0,0,55,90,215,119,246,170,187,85,91,226,110,181,174,239,237,85,118,170,183,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,13,6,123,2,174,1,156,17,25,17,106,2,86,20,105,2,0,0,55,90,215,119,246,170,181,170,187,226,110,181,174,239,237,85,107,85,119,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,3,6,127,2,167,1,154,17,26,17,109,2,86,20,105,2,0,0,55,90,215,119,246,170,181,85,95,226,110,181,174,239,237,85,106,170,191,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,18,6,120,2,177,1,193,17,236,16,105,2,78,20,118,2,0,0,55,90,215,119,246,170,182,170,183,226,110,181,174,239,237,85,109,85,111,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,252,5,129,2,175,1,199,17,224,16,107,2,79,20,107,2,0,0,55,90,215,119,246,170,183,85,107,226,110,181,174,239,237,85,110,170,215,194],
    },
    ////////////////////////////////////////////////
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [199,0,5,123,2,21,6,158,17,236,16,119,2,184,1,120,2,59,20,104,2,0,0,103,38,76,156,228,252,228,146,73,36,146,127,197,156,153,50,115,147,243,146,73,36,146,73,255,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [199,0,5,119,2,9,6,124,2,179,1,200,17,233,16,108,2,89,20,117,2,0,0,55,90,215,117,251,170,170,213,123,226,110,181,174,235,247,85,85,170,247,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [199,0,5,121,2,8,6,122,2,183,1,201,17,245,16,104,2,64,20,106,2,0,0,55,90,215,117,251,170,171,170,235,226,110,181,174,235,247,85,87,85,215,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [199,0,5,123,2,254,5,130,2,174,1,226,17,231,16,108,2,62,20,108,2,0,0,55,90,215,117,251,170,171,85,119,226,110,181,174,235,247,85,86,170,239,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [199,0,5,119,2,21,6,118,2,182,1,164,17,19,17,105,2,60,20,117,2,0,0,55,90,215,117,251,170,174,170,215,226,110,181,174,235,247,85,93,85,175,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [199,0,5,124,2,10,6,124,2,176,1,194,17,223,16,106,2,86,20,106,2,0,0,55,90,215,117,251,170,175,85,171,226,110,181,174,235,247,85,94,171,87,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [199,0,5,120,2,21,6,120,2,186,1,189,17,234,16,102,2,80,20,101,2,0,0,55,90,215,117,251,170,173,170,219,226,110,181,174,235,247,85,91,85,183,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [199,0,5,118,2,20,6,119,2,181,1,185,17,235,16,101,2,88,20,105,2,0,0,55,90,215,117,251,170,173,85,111,226,110,181,174,235,247,85,90,170,223,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [199,0,5,118,2,10,6,122,2,179,1,167,17,12,17,112,2,62,20,105,2,0,0,55,90,215,117,251,170,186,170,175,226,110,181,174,235,247,85,117,85,95,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [199,0,5,127,2,7,6,122,2,183,1,203,17,204,16,104,2,85,20,105,2,0,0,55,90,215,117,251,170,187,85,91,226,110,181,174,235,247,85,118,170,183,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [199,0,5,120,2,18,6,119,2,186,1,213,17,223,16,104,2,62,20,107,2,0,0,55,90,215,117,251,170,181,170,187,226,110,181,174,235,247,85,107,85,119,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [199,0,5,118,2,15,6,122,2,178,1,127,17,35,17,106,2,60,20,104,2,0,0,55,90,215,117,251,170,181,85,95,226,110,181,174,235,247,85,106,170,191,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [199,0,5,120,2,20,6,118,2,185,1,193,17,219,16,106,2,84,20,104,2,0,0,55,90,215,117,251,170,182,170,183,226,110,181,174,235,247,85,109,85,111,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [199,0,5,122,2,19,6,119,2,185,1,197,17,220,16,106,2,59,20,109,2,0,0,55,90,215,117,251,170,183,85,107,226,110,181,174,235,247,85,110,170,215,194],
    },
    /////////////////////////////////////////////////////
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [199,0,5,118,2,13,6,195,17,228,16,123,2,177,1,104,2,87,20,104,2,0,0,103,38,76,156,204,254,100,146,73,36,146,127,197,156,153,50,115,51,249,146,73,36,146,73,255,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [199,0,5,128,2,4,6,127,2,167,1,181,17,229,16,111,2,67,20,109,2,0,0,55,90,215,109,253,170,170,213,123,226,110,181,174,219,251,85,85,170,247,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [199,0,5,123,2,7,6,123,2,177,1,155,17,16,17,105,2,81,20,103,2,0,0,55,90,215,109,253,170,171,170,235,226,110,181,174,219,251,85,87,85,215,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [199,0,5,119,2,6,6,156,17,29,17,122,2,181,1,106,2,91,20,104,2,0,0,103,38,76,156,204,254,100,146,73,146,73,207,197,156,153,50,115,51,249,146,73,38,73,39,63,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [199,0,5,120,2,10,6,123,2,175,1,212,17,237,16,106,2,78,20,104,2,0,0,55,90,215,109,253,170,174,170,215,226,110,181,174,219,251,85,93,85,175,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [199,0,5,122,2,16,6,120,2,180,1,202,17,221,16,101,2,79,20,104,2,0,0,55,90,215,109,253,170,175,85,171,226,110,181,174,219,251,85,94,171,87,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [199,0,5,122,2,9,6,220,17,235,16,121,2,177,1,106,2,58,20,105,2,0,0,103,38,76,156,204,254,100,146,76,201,38,103,197,156,153,50,115,51,249,146,73,51,36,153,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [199,0,5,125,2,5,6,127,2,170,1,221,17,238,16,108,2,78,20,107,2,0,0,55,90,215,109,253,170,173,85,111,226,110,181,174,219,251,85,90,170,223,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [199,0,5,122,2,8,6,125,2,169,1,199,17,223,16,106,2,80,20,107,2,0,0,55,90,215,109,253,170,186,170,175,226,110,181,174,219,251,85,117,85,95,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [199,0,5,122,2,4,6,154,17,2,17,120,2,169,1,105,2,78,20,106,2,0,0,103,38,76,156,204,254,100,146,115,36,146,103,197,156,153,50,115,51,249,146,73,204,146,73,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [199,0,5,118,2,14,6,118,2,177,1,196,17,234,16,105,2,75,20,103,2,0,0,55,90,215,109,253,170,181,170,187,226,110,181,174,219,251,85,107,85,119,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [199,0,5,119,2,17,6,119,2,185,1,157,17,16,17,102,2,77,20,103,2,0,0,55,90,215,109,253,170,181,85,95,226,110,181,174,219,251,85,106,170,191,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [199,0,5,118,2,16,6,128,17,30,17,118,2,185,1,118,2,75,20,104,2,0,0,103,38,76,156,204,254,100,146,102,73,36,207,197,156,153,50,115,51,249,146,73,153,36,147,63,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [199,0,5,118,2,17,6,118,2,186,1,196,17,238,16,116,2,81,20,104,2,0,0,55,90,215,109,253,170,183,85,107,226,110,181,174,219,251,85,110,170,215,194],
    },
    //////////////////////////////////////////////////////////
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,119,2,9,6,130,2,175,1,201,17,229,16,105,2,56,20,105,2,0,0,55,90,215,107,254,170,170,170,191,226,110,181,174,215,253,85,85,85,127,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,120,2,11,6,125,2,172,1,190,17,213,16,106,2,83,20,107,2,0,0,55,90,215,107,254,170,170,213,123,226,110,181,174,215,253,85,85,170,247,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,119,2,19,6,119,2,180,1,196,17,216,16,102,2,79,20,105,2,0,0,55,90,215,107,254,170,171,170,235,226,110,181,174,215,253,85,87,85,215,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,0,6,130,17,21,17,131,2,171,1,109,2,82,20,109,2,0,0,103,38,76,156,201,255,36,146,73,146,73,207,197,156,153,50,115,39,252,146,73,38,73,39,63,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,5,6,126,2,178,1,195,17,238,16,102,2,57,20,105,2,0,0,55,90,215,107,254,170,174,170,215,226,110,181,174,215,253,85,93,85,175,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,126,2,254,5,129,2,174,1,218,17,213,16,105,2,80,20,105,2,0,0,55,90,215,107,254,170,175,85,171,226,110,181,174,215,253,85,94,171,87,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,120,2,13,6,190,17,228,16,119,2,179,1,105,2,64,20,114,2,0,0,103,38,76,156,201,255,36,146,76,201,38,103,197,156,153,50,115,39,252,146,73,51,36,153,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,137,2,6,6,123,2,179,1,188,17,189,16,102,2,80,20,113,2,0,0,55,90,215,107,254,170,173,85,111,226,110,181,174,215,253,85,90,170,223,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,17,6,122,2,184,1,127,17,28,17,102,2,77,20,108,2,0,0,55,90,215,107,254,170,186,170,175,226,110,181,174,215,253,85,117,85,95,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,119,2,15,6,219,17,235,16,119,2,184,1,103,2,74,20,104,2,0,0,103,38,76,156,201,255,36,146,115,36,146,103,197,156,153,50,115,39,252,146,73,204,146,73,159,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,117,2,20,6,117,2,184,1,180,17,253,16,118,2,78,20,112,2,0,0,55,90,215,107,254,170,181,170,187,226,110,181,174,215,253,85,107,85,119,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,16,6,123,2,185,1,185,17,27,17,104,2,89,20,103,2,0,0,55,90,215,107,254,170,181,85,95,226,110,181,174,215,253,85,106,170,191,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,10,6,122,2,175,1,197,17,217,16,107,2,72,20,105,2,0,0,55,90,215,107,254,170,182,170,183,226,110,181,174,215,253,85,109,85,111,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,117,2,18,6,118,2,181,1,195,17,251,16,104,2,78,20,113,2,0,0,55,90,215,107,254,170,183,85,107,226,110,181,174,215,253,85,110,170,215,194],
    },
    //////////////////////////////Heat////////////////////////////////
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,124,2,2,6,130,2,168,1,204,17,218,16,108,2,75,20,107,2,0,0,55,90,215,119,246,170,170,186,250,226,110,181,174,239,237,85,85,117,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,121,2,14,6,120,2,175,1,183,17,237,16,104,2,84,20,104,2,0,0,55,90,215,119,246,170,170,245,234,226,110,181,174,239,237,85,85,235,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,122,2,3,6,196,17,217,16,125,2,168,1,105,2,71,20,106,2,0,0,103,38,76,156,231,243,36,146,73,242,114,73,197,156,153,50,115,159,204,146,73,39,201,201,39,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,124,2,252,5,128,2,167,1,186,17,250,16,108,2,72,20,107,2,0,0,55,90,215,119,246,170,171,117,218,226,110,181,174,239,237,85,86,235,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,5,6,119,2,176,1,193,17,227,16,105,2,69,20,105,2,0,0,55,90,215,119,246,170,174,235,90,226,110,181,174,239,237,85,93,214,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,121,2,5,6,125,2,171,1,124,17,30,17,108,2,77,20,107,2,0,0,55,90,215,119,246,170,175,214,170,226,110,181,174,239,237,85,95,173,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,121,2,9,6,120,2,173,1,194,17,230,16,107,2,75,20,106,2,0,0,55,90,215,119,246,170,173,235,106,226,110,181,174,239,237,85,91,214,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,121,2,6,6,163,17,21,17,120,2,173,1,105,2,83,20,105,2,0,0,103,38,76,156,231,243,36,146,76,156,153,201,197,156,153,50,115,159,204,146,73,50,114,103,39,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,11,6,120,2,175,1,155,17,17,17,105,2,75,20,104,2,0,0,55,90,215,119,246,170,186,234,186,226,110,181,174,239,237,85,117,213,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,134,2,248,5,134,2,162,1,218,17,210,16,113,2,81,20,114,2,0,0,55,90,215,119,246,170,187,213,106,226,110,181,174,239,237,85,119,170,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,6,6,123,2,176,1,193,17,224,16,104,2,86,20,106,2,0,0,55,90,215,119,246,170,181,234,234,226,110,181,174,239,237,85,107,213,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,5,6,124,2,171,1,169,17,239,16,106,2,80,20,108,2,0,0,55,90,215,119,246,170,181,117,122,226,110,181,174,239,237,85,106,234,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,124,2,255,5,122,2,170,1,196,17,222,16,106,2,75,20,107,2,0,0,55,90,215,119,246,170,182,234,218,226,110,181,174,239,237,85,109,213,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,133,2,13,6,121,2,177,1,189,17,201,16,113,2,76,20,103,2,0,0,55,90,215,119,246,170,183,213,170,226,110,181,174,239,237,85,111,171,85,194],
    },
    /////////////////////////////////////////////////////////
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [199,0,5,118,2,11,6,122,2,177,1,146,17,14,17,106,2,47,20,101,2,0,0,55,90,215,117,251,170,170,186,250,226,110,181,174,235,247,85,85,117,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [199,0,5,120,2,6,6,199,17,218,16,125,2,170,1,106,2,71,20,107,2,0,0,103,38,76,156,228,252,228,146,73,60,158,73,197,156,153,50,115,147,243,146,73,36,242,121,39,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [199,0,5,126,2,5,6,128,2,168,1,124,17,6,17,108,2,57,20,109,2,0,0,55,90,215,117,251,170,171,235,170,226,110,181,174,235,247,85,87,215,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [199,0,5,131,2,4,6,126,2,166,1,199,17,210,16,111,2,73,20,108,2,0,0,55,90,215,117,251,170,171,117,218,226,110,181,174,235,247,85,86,235,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [199,0,5,123,2,6,6,123,2,170,1,200,17,224,16,107,2,80,20,107,2,0,0,55,90,215,117,251,170,174,235,90,226,110,181,174,235,247,85,93,214,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [199,0,5,127,2,251,5,129,2,173,1,198,17,203,16,110,2,76,20,109,2,0,0,55,90,215,117,251,170,175,214,170,226,110,181,174,235,247,85,95,173,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [199,0,5,130,2,16,6,119,2,182,1,121,17,251,16,100,2,70,20,101,2,0,0,55,90,215,117,251,170,173,235,106,226,110,181,174,235,247,85,91,214,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [199,0,5,119,2,9,6,120,2,177,1,200,17,231,16,103,2,88,20,105,2,0,0,55,90,215,117,251,170,173,117,186,226,110,181,174,235,247,85,90,235,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [199,0,5,122,2,8,6,123,2,174,1,193,17,219,16,104,2,53,20,104,2,0,0,55,90,215,117,251,170,186,234,186,226,110,181,174,235,247,85,117,213,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [199,0,5,121,2,13,6,118,2,182,1,148,17,25,17,105,2,80,20,113,2,0,0,55,90,215,117,251,170,187,213,106,226,110,181,174,235,247,85,119,170,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [199,0,5,126,2,254,5,124,2,174,1,201,17,217,16,105,2,55,20,104,2,0,0,55,90,215,117,251,170,181,234,234,226,110,181,174,235,247,85,107,213,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [199,0,5,120,2,7,6,121,2,174,1,166,17,242,16,104,2,53,20,104,2,0,0,55,90,215,117,251,170,181,117,122,226,110,181,174,235,247,85,106,234,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [199,0,5,122,2,13,6,119,2,176,1,190,17,217,16,102,2,81,20,103,2,0,0,55,90,215,117,251,170,182,234,218,226,110,181,174,235,247,85,109,213,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [199,0,5,124,2,9,6,121,2,179,1,225,17,209,16,103,2,58,20,103,2,0,0,55,90,215,117,251,170,183,213,170,226,110,181,174,235,247,85,111,171,85,194],
    },
    ////////////////////////////////////////////////////////////////
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [199,0,5,124,2,3,6,125,2,178,1,193,17,228,16,106,2,81,20,106,2,0,0,55,90,215,109,253,170,170,186,250,226,110,181,174,219,251,85,85,117,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [199,0,5,123,2,1,6,126,2,170,1,195,17,230,16,107,2,66,20,106,2,0,0,55,90,215,109,253,170,170,245,234,226,110,181,174,219,251,85,85,235,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [199,0,5,119,2,9,6,121,2,175,1,153,17,13,17,103,2,70,20,105,2,0,0,55,90,215,109,253,170,171,235,170,226,110,181,174,219,251,85,87,215,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [199,0,5,123,2,7,6,120,2,171,1,182,17,241,16,104,2,69,20,105,2,0,0,55,90,215,109,253,170,171,117,218,226,110,181,174,219,251,85,86,235,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [199,0,5,121,2,8,6,120,2,172,1,179,17,23,17,105,2,74,20,105,2,0,0,55,90,215,109,253,170,174,235,90,226,110,181,174,219,251,85,93,214,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [199,0,5,120,2,11,6,119,2,177,1,127,17,18,17,104,2,72,20,105,2,0,0,55,90,215,109,253,170,175,214,170,226,110,181,174,219,251,85,95,173,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [199,0,5,125,2,9,6,118,2,173,1,145,17,249,16,105,2,63,20,103,2,0,0,55,90,215,109,253,170,173,235,106,226,110,181,174,219,251,85,91,214,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [199,0,5,125,2,14,6,117,2,178,1,153,17,8,17,102,2,74,20,112,2,0,0,55,90,215,109,253,170,173,117,186,226,110,181,174,219,251,85,90,235,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [199,0,5,121,2,13,6,120,2,174,1,167,17,237,16,106,2,71,20,104,2,0,0,55,90,215,109,253,170,186,234,186,226,110,181,174,219,251,85,117,213,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [199,0,5,123,2,1,6,122,2,171,1,195,17,212,16,103,2,70,20,105,2,0,0,55,90,215,109,253,170,187,213,106,226,110,181,174,219,251,85,119,170,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [199,0,5,128,2,2,6,122,2,170,1,190,17,208,16,107,2,76,20,104,2,0,0,55,90,215,109,253,170,181,234,234,226,110,181,174,219,251,85,107,213,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [199,0,5,122,2,8,6,119,2,178,1,193,17,210,16,105,2,65,20,106,2,0,0,55,90,215,109,253,170,181,117,122,226,110,181,174,219,251,85,106,234,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [199,0,5,131,2,0,6,123,2,167,1,185,17,234,16,110,2,68,20,108,2,0,0,55,90,215,109,253,170,182,234,218,226,110,181,174,219,251,85,109,213,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [199,0,5,124,2,2,6,121,2,177,1,216,17,212,16,105,2,74,20,105,2,0,0,55,90,215,109,253,170,183,213,170,226,110,181,174,219,251,85,111,171,85,194],
    },
    /////////////////////////////////////////////////////////////////
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,255,5,128,2,176,1,190,17,222,16,104,2,82,20,105,2,0,0,55,90,215,107,254,170,170,186,250,226,110,181,174,215,253,85,85,117,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,121,2,5,6,124,2,172,1,128,17,16,17,105,2,77,20,103,2,0,0,55,90,215,107,254,170,170,245,234,226,110,181,174,215,253,85,85,235,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,9,6,123,2,174,1,149,17,21,17,103,2,75,20,105,2,0,0,55,90,215,107,254,170,171,235,170,226,110,181,174,215,253,85,87,215,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,126,2,249,5,130,2,169,1,163,17,10,17,108,2,68,20,109,2,0,0,55,90,215,107,254,170,171,117,218,226,110,181,174,215,253,85,86,235,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,249,5,127,2,169,1,222,17,226,16,108,2,77,20,107,2,0,0,55,90,215,107,254,170,174,235,90,226,110,181,174,215,253,85,93,214,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,119,2,4,6,124,2,173,1,196,17,216,16,105,2,77,20,104,2,0,0,55,90,215,107,254,170,175,214,170,226,110,181,174,215,253,85,95,173,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,7,6,119,2,175,1,182,17,241,16,103,2,74,20,103,2,0,0,55,90,215,107,254,170,173,235,106,226,110,181,174,215,253,85,91,214,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,121,2,12,6,119,2,174,1,195,17,232,16,107,2,66,20,103,2,0,0,55,90,215,107,254,170,173,117,186,226,110,181,174,215,253,85,90,235,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,1,6,126,2,171,1,223,17,218,16,104,2,75,20,105,2,0,0,55,90,215,107,254,170,186,234,186,226,110,181,174,215,253,85,117,213,117,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,116,2,20,6,116,2,185,1,165,17,4,17,105,2,71,20,103,2,0,0,55,90,215,107,254,170,187,213,106,226,110,181,174,215,253,85,119,170,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,117,2,9,6,121,2,180,1,164,17,8,17,104,2,80,20,103,2,0,0,55,90,215,107,254,170,181,234,234,226,110,181,174,215,253,85,107,213,213,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,119,2,7,6,123,2,174,1,190,17,248,16,105,2,78,20,105,2,0,0,55,90,215,107,254,170,181,117,122,226,110,181,174,215,253,85,106,234,245,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,120,2,15,6,118,2,180,1,173,17,255,16,103,2,73,20,104,2,0,0,55,90,215,107,254,170,182,234,218,226,110,181,174,215,253,85,109,213,181,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,118,2,8,6,122,2,179,1,188,17,218,16,103,2,77,20,105,2,0,0,55,90,215,107,254,170,183,213,170,226,110,181,174,215,253,85,111,171,85,194],
    },
    //////////////////////////AUTO////////////////////////////
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,131,2,7,6,124,2,175,1,190,17,196,16,105,2,57,20,104,2,0,0,55,90,215,106,255,170,170,181,125,226,110,181,174,213,255,85,85,106,251,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,119,2,13,6,120,2,183,1,166,17,4,17,107,2,55,20,106,2,0,0,55,90,215,106,255,170,170,234,245,226,110,181,174,213,255,85,85,213,235,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,15,6,119,2,182,1,186,17,214,16,115,2,52,20,102,2,0,0,55,90,215,106,255,170,171,213,213,226,110,181,174,213,255,85,87,171,171,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,7,6,121,2,178,1,185,17,215,16,101,2,72,20,105,2,0,0,55,90,215,106,255,170,171,106,237,226,110,181,174,213,255,85,86,213,219,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,119,2,5,6,122,2,174,1,116,17,26,17,103,2,83,20,105,2,0,0,55,90,215,106,255,170,174,213,173,226,110,181,174,213,255,85,93,171,91,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,142,2,8,6,123,2,174,1,193,17,179,16,106,2,48,20,105,2,0,0,55,90,215,106,255,170,175,171,85,226,110,181,174,213,255,85,95,86,171,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,122,2,5,6,122,2,176,1,159,17,14,17,105,2,72,20,106,2,0,0,55,90,215,106,255,170,173,213,181,226,110,181,174,213,255,85,91,171,107,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,128,2,2,6,128,2,167,1,210,17,228,16,112,2,86,20,111,2,0,0,55,90,215,106,255,170,173,106,221,226,110,181,174,213,255,85,90,213,187,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,4,6,123,2,181,1,179,17,3,17,106,2,43,20,106,2,0,0,55,90,215,106,255,170,186,213,93,226,110,181,174,213,255,85,117,170,187,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,122,2,5,6,124,2,171,1,196,17,215,16,107,2,53,20,106,2,0,0,55,90,215,106,255,170,187,170,181,226,110,181,174,213,255,85,119,85,107,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,119,2,5,6,125,2,169,1,188,17,218,16,105,2,53,20,104,2,0,0,55,90,215,106,255,170,181,213,117,226,110,181,174,213,255,85,107,170,235,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,130,2,0,6,128,2,169,1,140,17,237,16,108,2,68,20,109,2,0,0,55,90,215,106,255,170,181,106,189,226,110,181,174,213,255,85,106,213,123,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,14,6,119,2,177,1,181,17,225,16,104,2,67,20,104,2,0,0,55,90,215,106,255,170,182,213,109,226,110,181,174,213,255,85,109,170,219,194],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,131,2,249,5,132,2,167,1,199,17,215,16,111,2,86,20,112,2,0,0,55,90,215,106,255,170,183,170,213,226,110,181,174,213,255,85,111,85,171,194],
    },
    ///////////////////////////DRY//////////////////////////////
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,119,2,9,6,124,2,177,1,194,17,215,16,105,2,75,20,105,2,0,0,55,90,215,106,255,170,170,173,126,226,110,181,174,213,255,85,85,90,253,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,138,2,3,6,124,2,170,1,186,17,182,16,104,2,69,20,108,2,0,0,55,90,215,106,255,170,170,218,246,226,110,181,174,213,255,85,85,181,237,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,121,2,11,6,122,2,171,1,199,17,248,16,106,2,76,20,104,2,0,0,55,90,215,106,255,170,171,181,214,226,110,181,174,213,255,85,87,107,173,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,132,2,250,5,131,2,163,1,161,17,11,17,110,2,88,20,110,2,0,0,55,90,215,106,255,170,171,90,238,226,110,181,174,213,255,85,86,181,221,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,5,6,123,2,172,1,177,17,240,16,107,2,78,20,104,2,0,0,55,90,215,106,255,170,174,181,174,226,110,181,174,213,255,85,93,107,93,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,255,5,126,2,168,1,198,17,215,16,106,2,71,20,106,2,0,0,55,90,215,106,255,170,175,107,86,226,110,181,174,213,255,85,94,214,173,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,120,2,17,6,118,2,177,1,175,17,17,17,111,2,55,20,102,2,0,0,55,90,215,106,255,170,173,181,182,226,110,181,174,213,255,85,91,107,109,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,126,2,255,5,128,2,165,1,149,17,15,17,107,2,65,20,106,2,0,0,55,90,215,106,255,170,173,90,222,226,110,181,174,213,255,85,90,181,189,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,118,2,11,6,118,2,174,1,203,17,217,16,106,2,76,20,104,2,0,0,55,90,215,106,255,170,186,181,94,226,110,181,174,213,255,85,117,106,189,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,123,2,10,6,120,2,175,1,194,17,216,16,110,2,68,20,104,2,0,0,55,90,215,106,255,170,187,106,182,226,110,181,174,213,255,85,118,213,109,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,125,2,6,6,123,2,167,1,149,17,11,17,107,2,78,20,108,2,0,0,55,90,215,106,255,170,181,181,118,226,110,181,174,213,255,85,107,106,237,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,147,2,249,5,132,2,165,1,200,17,170,16,110,2,52,20,111,2,0,0,55,90,215,106,255,170,181,90,190,226,110,181,174,213,255,85,106,181,125,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,126,2,253,5,127,2,168,1,193,17,210,16,108,2,63,20,109,2,0,0,55,90,215,106,255,170,182,181,110,226,110,181,174,213,255,85,109,106,221,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,133,2,12,6,120,2,173,1,160,17,229,16,105,2,79,20,105,2,0,0,55,90,215,106,255,170,183,106,214,226,110,181,174,213,255,85,110,213,173,194],
    },
    /////////////////////////FAN//////////////////////////////
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [199,0,5,125,2,5,6,126,2,172,1,194,17,210,16,107,2,71,20,109,2,0,0,55,90,215,119,246,170,189,106,174,226,110,181,174,239,237,85,122,213,93,194],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [199,0,5,135,2,243,5,133,2,163,1,199,17,191,16,105,2,54,20,108,2,0,0,55,90,215,117,251,170,189,106,174,226,110,181,174,235,247,85,122,213,93,194],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [199,0,5,123,2,0,6,122,2,170,1,145,17,253,16,106,2,69,20,104,2,0,0,55,90,215,109,253,170,189,106,174,226,110,181,174,219,251,85,122,213,93,194],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [199,0,5,123,2,255,5,124,2,175,1,156,17,2,17,106,2,73,20,107,2,0,0,55,90,215,107,254,170,189,106,174,226,110,181,174,215,253,85,122,213,93,194],
    },
  ]
};

export default HYUNDAI_ESAF_09HN1